module.exports = __webpack_public_path__ + "img/icon.16395ce2.png";